import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import TaskList from '@/components/TaskList'
import UserList from '@/components/UserList'
import Component1 from '@/components/Component1'
import Component2 from '@/components/Component2'
import ImagePreloader from '@/components/ImagePreloader'
// import Depth2 from '@/components/Depth2'
import Docs from '@/components/Docs'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/tasks',
      name: 'TaskList',
      component: TaskList
    },
    {
      path: '/users',
      name: 'UserList',
      component: UserList
    },
    {
      path: '/component_1',
      name: 'Component1',
      component: Component1
    },
    {
      path: '/component_2',
      name: 'Component2',
      component: Component2
    },
    // {
    //   path: '/component_1/component_2',
    //   name: 'Component2',
    //   component: Component2
    // },
    // {
    //   path: '/docs/component_1/component_2',
    //   name: 'Component2',
    //   component: Component2
    // },
    // {
    //   path: '/docs/parent/depth_1/depth_2',
    //   name: 'Depth2',
    //   component: Depth2
    // },
    {
      path: '/docs',
      name: 'Docs',
      component: Docs,
      props: (route) => ({
        ...route.params
      })
    },
    {
      path: '/image_preloader',
      name: 'ImagePreloader',
      component: ImagePreloader,
      props: (route) => ({
        callback: () => {
          alert('Default image loaded function')
        },
        ...route.params // this will be used as props in the ImagePreloader component
      })
    }
  ]
})

router.beforeEach((to, from, next) => {
  let docsPath = '/docs/'
  let urlPath = to.path
  let startsWithDocs = urlPath.lastIndexOf(docsPath, 0) === 0
  if (startsWithDocs) {
    let urlAfterDocs = urlPath.substring(docsPath.length)
    let urlParams = urlAfterDocs.split('/')
    let routeObj = {
      path: urlPath,
      name: urlPath,
      component: Docs,
      props: (route) => ({
        urlParams: urlParams
      })
    }
    let hasPath = false
    let allRoutes = router.options.routes
    for (let route of allRoutes) {
      if (route.path === routeObj.path) {
        hasPath = true
        break
      }
    }
    if (!hasPath) {
      let newRoute = []
      newRoute.push(routeObj)
      router.addRoutes(newRoute)
      router.options.routes.push(routeObj)
    }
  }
  console.log('routes: ', router.options.routes)
  console.log('path from: ', from.path)
  console.log('path to: ', to.path)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js